<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        コンテンツ {{ title }}
      </template>

      <template v-slot:content>
        <v-tabs v-model="tab" color="secondary">
          <v-tab>基本情報</v-tab>
          <v-tab>設問一覧</v-tab>
          <v-tab>画像管理</v-tab>
          <v-tab>教科書ページ</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-content-form @submit="submit" />
          </v-tab-item>
          <v-tab-item>
            <v-content-question-table
              :questions="questions"
              :content-images="contentImages"
              :content-id="contentId"
              @updated="reloadDetail"
            />
          </v-tab-item>
          <v-tab-item>
            <v-content-image-manager
              :content-images="contentImages"
              :content-id="contentId"
              @updated="reloadDetail"
            />
          </v-tab-item>
          <v-tab-item>
            <v-content-page-table
              :content-pages="contentPages"
              :content-id="contentId"
              @updated="reloadDetail"
            />
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VContentForm from '@/components/organizms/ContentForm.vue'
import VContentQuestionTable from '@/components/organizms/ContentQuestionTable.vue'
import VContentImageManager from '@/components/organizms/ContentImageManager.vue'
import VContentPageTable from '@/components/organizms/ContentPageTable.vue'

export default {
  components: {
    VBaseCard,
    VContentForm,
    VContentQuestionTable,
    VContentImageManager,
    VContentPageTable,
  },

  data() {
    return {
      tab: 0,
      questions: [],
      contentImages: {},
      contentPages: [],
    }
  },

  async mounted() {
    await this.loadDetail()
  },

  beforeDestroy() {
    this.$store.commit('content/initialize')
  },

  computed: {
    title() {
      return this.$store.getters['content/title']
    },
    contentId() {
      return parseInt(this.$route.params.id)
    },
  },

  methods: {
    async loadDetail() {
      this.$app.$refs.loading.open({ message: '読み込み中です。少々お待ちください。' })
      const res = await this.$axios(`/api/v1/admin/contents/${this.contentId}`)
      const data = res.data
      this.$store.commit('content/setContent', data)
      this.questions = data.questions || []
      this.contentImages = data.content_images || {}
      this.contentPages = data.content_pages || []
      this.$app.$refs.loading.close()
    },
    async reloadDetail() {
      const res = await this.$axios(`/api/v1/admin/contents/${this.contentId}`)
      const data = res.data
      this.$store.commit('content/setContent', data)
      this.questions = data.questions || []
      this.contentImages = data.content_images || {}
      this.contentPages = data.content_pages || []
    },
    async submit() {
      this.$app.$refs.loading.open({ message: '処理中です。少々お待ちください。' })
      const res = await this.$store.dispatch('content/submit')
      if (res.status === 'error') {
        this.$toasted.global.error({ message: res.message })
      } else {
        this.$toasted.global.success({ message: res.message })
        await this.reloadDetail()
      }
      this.$app.$refs.loading.close()
    },
  }
}
</script>

<style lang="stylus" scoped>
.select
  font-size: 11px !important;
</style>
